import { Modal, Typography } from "antd";
import { ReactComponent as NotiSuccessIcon } from "../../common/images/svg/NotiSuccess.svg";
// import { ReactComponent as NotiWarningIcon } from "../../common/images/svg/NotiWarning.svg";
import { ReactComponent as NotiErrorIcon } from "../../common/images/svg/NotiError.svg";
import { ReactComponent as NotiInfoIcon } from "../../common/images/svg/NotiInfo.svg";
import WarningIcon from "../../common/images/png/WarningIcon.png";

import { ButtonOutlinedCustom } from "../button/buttonOulined";
import { CustomButton } from "../button/buttonCustom";
import "./confirmModal.css";

interface IConfirmModal {
  type?: "success" | "warning" | "error" | "info";
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  textCancel?: string;
  textSubmit?: string;
  title: string;
  description?: string;
  isLoading?: boolean;
  showButtonCancel?: boolean;
  showButtonSubmit?: boolean;
  className?: string;
  contentCustom?: React.ReactNode;
}

const ConfirmModal = ({
  type = "info",
  open,
  onCancel,
  onSubmit,
  textCancel = "Cancel",
  textSubmit = "Confirm",
  title,
  description,
  isLoading,
  showButtonCancel = true,
  showButtonSubmit = true,
  className,
  contentCustom,
}: IConfirmModal) => {
  const renderIcon = () => {
    switch (type) {
      case "info":
        return <NotiInfoIcon style={{ width: 48, height: 48 }} />;
      case "error":
        return <NotiErrorIcon style={{ width: 48, height: 48 }} />;
      case "warning":
        return <img src={WarningIcon} style={{ width: 48, height: 48 }} />;
      case "success":
        return <NotiSuccessIcon style={{ width: 48, height: 48 }} />;
    }
  };
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      title={null}
      maskClosable={false}
      className={`confirm-modal ${className ?? ""}`}
    >
      <div className="modal-content">
        {renderIcon()}
        <div className="modal-text">
          <Typography className="modal-text-title">{title}</Typography>
          {contentCustom ? contentCustom : null}
          {description ? (
            <Typography className="modal-text-description">
              {description}
            </Typography>
          ) : null}
        </div>
        <div className="modal-button">
          {showButtonCancel ? (
            <ButtonOutlinedCustom
              size="large"
              width={"50%"}
              text={textCancel}
              onClick={onCancel}
              isLoading={isLoading}
            />
          ) : null}
          {showButtonSubmit ? (
            <CustomButton
              size="large"
              width={"50%"}
              text={textSubmit}
              onClick={onSubmit}
              isLoading={isLoading}
            />
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
